export default "__VITE_IMAGE_ASSET__da767525__";